// AuthButton.tsx

import { useMsal } from '@azure/msal-react';
// import { loginRequest } from '../../Auth/authConfig';

export const AuthButton: React.FC = () => {
  const { instance, accounts } = useMsal();

  const login = () => {
    console.log(instance)
    
  };

  const logout = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    instance.logoutRedirect();
  };

  return (
    <div>
      {accounts.length > 0 ? (
        <a href="" onClick={logout}>Logout</a>
      ) : (
        <a href="" onClick={login}>Login</a>
      )}
    </div>
  );
};
